'use client';

import { useState } from 'react';
import { useTranslations } from 'next-intl';
import { Field, Input, SettingsEditDialog } from '@terra/ui-design-system';

type ProxyValueAddDialogProps = {
  open: boolean;
  title: string;
  description?: string;
  label: string;
  placeholder?: string;
  submitText?: string;
  onAdd: (value: string) => void;
  onClose: () => void;
};

export function ProxyValueAddDialog({
  open,
  title,
  description,
  label,
  placeholder,
  submitText,
  onAdd,
  onClose,
}: ProxyValueAddDialogProps) {
  const tCommon = useTranslations('common');
  const [value, setValue] = useState('');
  const trimmedValue = value.trim();

  const close = () => {
    setValue('');
    onClose();
  };

  const handleSubmit = () => {
    if (!trimmedValue) {
      return;
    }

    onAdd(trimmedValue);
    close();
  };

  return (
    <SettingsEditDialog
      open={open}
      title={title}
      description={description}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) close();
      }}
      onSubmit={handleSubmit}
      submitText={submitText ?? tCommon('add')}
      cancelText={tCommon('cancel')}
      isSubmitDisabled={!trimmedValue}
    >
      <Field.Root w="full">
        <Field.Label>{label}</Field.Label>
        <Input
          size="sm"
          value={value}
          onChange={(event) => setValue(event.target.value)}
          placeholder={placeholder}
        />
      </Field.Root>
    </SettingsEditDialog>
  );
}
